document.addEventListener('DOMContentLoaded', function () {
    // Affichage du tooltip :
    let dynamicTooltip = document.querySelector('#dynamicTooltip');

    if (dynamicTooltip !== null) {
        let map = document.querySelector('#map-svg');
        let regions = map.querySelectorAll('.region');

        map.onmousemove = function (e) {
            if (e.target.classList.contains('region')) {
                let region = e.target;
                dynamicTooltip.textContent = region.getAttribute('data-region');
                dynamicTooltip.style.display = 'block';
                let x = e.clientX;
                let y = e.clientY;
                dynamicTooltip.style.top = (y - 40) + 'px';
                dynamicTooltip.style.left = (x - 50) + 'px';
            } else {
                dynamicTooltip.style.display = 'none';
            }
        }

        map.onclick = function (event) {
            // Function slugify : https://lucidar.me/en/web-dev/how-to-slugify-a-string-in-javascript/
            function slugify(str) {
                str = str.replace(/^\s+|\s+$/g, '');

                // Make the string lowercase
                str = str.toLowerCase();

                // Remove accents, swap ñ for n, etc
                var from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
                var to = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------";
                for (var i = 0, l = from.length; i < l; i++) {
                    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
                }

                // Remove invalid chars
                str = str.replace(/[^a-z0-9 -]/g, '')
                    // Collapse whitespace and replace by -
                    .replace(/\s+/g, '-')
                    // Collapse dashes
                    .replace(/-+/g, '-');

                return str;
            }

            location.href = slugify(event.target.getAttribute('data-region'))
        }
    }
})
